export enum Icons{
  info ='info-custom',
  error = 'error-custom',
  success = 'check-custom',
  none = 'none'
}
